import React, { ReactNode, useMemo } from 'react';
import arrowIcon from '@ingka/ssr-icon/paths/arrow-right';
import SSRIcon from '@ingka/ssr-icon';
import {
  ArrowIcon,
  ButtonWrapper,
  Children,
  Content,
  ImageWrapper,
  Label,
  Eventtitle,
  Wrapper,
  SlideShowWrapper,
  CardLink,
} from './style';
import Badges, { Colors } from './Badges';
import AspectRatioImage from '../AspectRatioImage';
import ConditionalRender from '../ConditionalRender';

type PropsType = {
  title: string;
  label: string;
  aspectRatioImageProps: {
    src: string;
    srcSet: string;
    ratio: 'square' | 'standard' | 'wide' | 'portrait';
    loading?: string;
  };
  children: ReactNode;
  buttonText: string;
  badges?: [string, Colors][];
  eventPath: string;
  inSlideShow: boolean;
  storeName?: string;
};

const Card = (props: PropsType) => {
  const WrapperElement = props.inSlideShow ? SlideShowWrapper : Wrapper;
  
  const titleId = useMemo(
    () => `card-title-${props.eventPath.replace(/[^a-zA-Z0-9]/g, '-')}`,
    [props.eventPath]
  );
  return (
    <CardLink to={props.eventPath} aria-labelledby={titleId}>
      <WrapperElement>
        <Content>
          <Eventtitle role="heading" aria-level={3} id={titleId}>
            {props.title}
          </Eventtitle>
          <ConditionalRender predicate={Boolean(props.storeName)}>
            <p> {props.storeName} </p>
          </ConditionalRender>
          <Label>
            {props.label}  
          </Label>
          <Children>
            <>{props.children}</>
          </Children>
          <ButtonWrapper>
            <ArrowIcon aria-hidden="true">
              <SSRIcon paths={arrowIcon} />
            </ArrowIcon>
          </ButtonWrapper>
        </Content>
        <ImageWrapper>
          <Badges badges={props.badges || []} />
            <AspectRatioImage
              src={props.aspectRatioImageProps.src}
              srcSet={props.aspectRatioImageProps.srcSet}
              ratio={props.aspectRatioImageProps.ratio}
              loading={props.aspectRatioImageProps.loading}
              alt={""}
            />
        </ImageWrapper>
      </WrapperElement>
    </CardLink>
  );
};

export default Card;